import type { FC } from 'react';
import { Redirect } from 'react-router-dom';

import { hasOnboardedAttendance } from '@/data/attendance/selectors/hasAttendance';
import { useWiwSelector } from '@/store';

export default function HasAttendance(ComposedComponent: FC) {
  return function HasAttendance(props?: any) {
    // biome-ignore lint/correctness/useHookAtTopLevel: legacy
    const isSetup = useWiwSelector(hasOnboardedAttendance);
    if (!isSetup) {
      return <Redirect to={CONFIG.APP_LEGACY_ROOT} />;
    }

    return <ComposedComponent {...props} />;
  };
}
